import { createContext, useContext } from 'react';

export const CurrentUserContext = createContext({
  user: null,
  isConnected: false,
  allowedActions: [],
  signIn: () => { },
  signUp: () => { },
  signOut: () => { },
  resetPassword: () => { },
  refetch: () => { },
  obtainBadge: () => { },
});

export const useCurrentUser = () => useContext(CurrentUserContext);

export const CurrentUserProvider = ({
  children,
  currentUser = null,
  allowedActions = [],
  signIn = () => { },
  signUp = () => { },
  signOut = () => { },
  resetPassword = () => { },
  refetch = () => { },
  obtainBadge = () => { },
}) => {
  return <CurrentUserContext.Provider value={{
    isConnected: !!currentUser,
    user: currentUser,
    allowedActions,
    signIn,
    signUp,
    signOut,
    resetPassword,
    refetch,
    obtainBadge,
  }}>{children}</CurrentUserContext.Provider>;
};
